// TenantVerification.jsx

import { useEffect, useState } from "react";
import {
  FaCheckCircle,
  FaUserAlt,
  FaBuilding,
  FaMoneyBillWave,
  FaEnvelope,
  FaPhoneAlt,
  FaCalendarAlt,
} from "react-icons/fa";

import "./TenantVerification.css";

const TenantVerification = () => {
  const [data, setData] = useState(null);

  const params = new URLSearchParams(window.location.search);
  const email = params.get("email");

  useEffect(() => {
    fetch(
      `https://ikaze-thouse-backend.vercel.app/api/v1/tenants/tenantByEmail/${email}`
    )
      .then((res) => res.json())
      .then((res) => setData(res.data));
  }, [email]);

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  if (!data) {
    return (
      <div className="verify-loader-container">
        <div className="verify-loader-card">
          <div className="verify-spinner"></div>

          <h2>Verifying Receipt...</h2>
          <p>Please wait a moment</p>
        </div>
      </div>
    );
  }

  return (
    <div className="verify-page">
      <div className="verify-card">

        {/* HEADER */}
        <div className="verify-header">
          <div className="verify-logo-circle">
            <span>TH</span>
          </div>

          <h1>GKM INVEST</h1>

          <p>Premium Property Management</p>
        </div>

        {/* VERIFIED */}
        <div className="verify-status-section">
          <FaCheckCircle className="verify-icon" />

          <h2>Receipt Verified</h2>

          <p>
            This tenant information has been successfully verified.
          </p>
        </div>

        {/* DETAILS */}
        <div className="verify-details">

          <div className="verify-item">
            <FaUserAlt className="verify-item-icon" />

            <div>
              <small>Tenant Name</small>
              <h4>{data.guest_name}</h4>
            </div>
          </div>

          <div className="verify-item">
            <FaBuilding className="verify-item-icon" />

            <div>
              <small>Apartment Unit</small>
              <h4>{data.appartment_unite}</h4>
            </div>
          </div>

          <div className="verify-item">
            <FaMoneyBillWave className="verify-item-icon" />

            <div>
              <small>Monthly Rent</small>
              <h4>${Number(data.rent).toLocaleString()}</h4>
            </div>
          </div>

          <div className="verify-item">
            <FaEnvelope className="verify-item-icon" />

            <div>
              <small>Email Address</small>
              <h4>{data.email_address}</h4>
            </div>
          </div>

          <div className="verify-item">
            <FaPhoneAlt className="verify-item-icon" />

            <div>
              <small>Phone Number</small>
              <h4>{data.mobile_number}</h4>
            </div>
          </div>

          <div className="verify-item">
            <FaCalendarAlt className="verify-item-icon" />

            <div>
              <small>Stay Period</small>

              <h4>
                {formatDate(data.arrival_date)} -{" "}
                {formatDate(data.departure_date)}
              </h4>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="verify-footer">
          <div className="verify-badge">
            VERIFIED AUTHENTIC DOCUMENT ✅
          </div>

          <p>
            Generated securely by GKM INVEST Management System
          </p>
        </div>
      </div>
    </div>
  );
};

export default TenantVerification;